import { FieldValidator } from "./"

export const validatePresence: FieldValidator = value => {
  let error = null

  if (!value) {
    error = "This field is required"
  }

  return error
}
